import React from 'react';
import ReactDOM from 'react-dom';
import {App} from "./components/App/App";

require('./hintbox.js');
import './category_menu.js';

function render_vehicle_app(){
    ReactDOM.render(<App/>, document.getElementById('react-root'));
}

window.render_vehicle_app = render_vehicle_app;
